"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This function validates if a string is a valid youtube url
 * @memberof StringUtils
 * @function isYoutubeURL
 * @param  {String} url to validate
 * @return {Boolean} true if valid youtube url 
 */
var isYoutubeURL = function isYoutubeURL(url) {
  return (/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/.test(url)
  );
};

exports.default = isYoutubeURL;